import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';

const SummaryCards = ({
  amountPaid,
  amountPending,
  amountExpired,
  amountPaidF,
  amountPendingF,
  amountExpiredF,
  filtrado,
  filters
}) => {
  const formatCurrency = (value) => {
    if (!value) return value;
    return parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const CardComponent = ({ backgroundColor, title, amount, fontSize = { xs: 15, md: 20 } }) => (
    <Grid item xs={12} sm={4} md={4}>
      <Paper
        elevation={3}
        sx={{
          backgroundColor,
          border: '1px solid lightgray',
          borderRadius: 2,
          marginTop: 1,
          padding: 2,
          width: { xs: '90%', sm: '75%', md: '66%', lg: '66%' },
          margin: 'auto',
        }}
      >
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography color="white" fontSize={{ xs: 20, md: 25 }} fontWeight="bold" fontFamily="Ubuntu" variant="h6" align="center">
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography color="white" fontSize={fontSize} fontWeight="bold" fontFamily="Ubuntu" variant="h6" align="center">
            {formatCurrency(amount)}
          </Typography>
        </Grid>
      </Paper>
    </Grid>
  );

  return (
    <Grid container spacing={2}>
      {/* Cards principais */}
      <CardComponent backgroundColor="#4CAF50" title="Recebido" amount={amountPaid} />
      <CardComponent backgroundColor="#FF9800" title="Pendente" amount={amountPending} />
      <CardComponent backgroundColor="#F44336" title="Expirado" amount={amountExpired} />

      {/* Cards filtrados */}
      {filtrado && (filters.descricao || filters.nome || filters.dataInicio || filters.dataFim || filters.telefone || filters.status) && (
        <>
          <CardComponent
            backgroundColor="#4CAF50"
            title="RECEBIDO"
            amount={amountPaidF}
            fontSize={{ xs: 12, md: 15 }}
          />
          <CardComponent
            backgroundColor="#FF9800"
            title="Pendente"
            amount={amountPendingF}
            fontSize={{ xs: 12, md: 15 }}
          />
          <CardComponent
            backgroundColor="#F44336"
            title="Expirado"
            amount={amountExpiredF}
            fontSize={{ xs: 12, md: 15 }}
          />
        </>
      )}
    </Grid>
  );
};

export default SummaryCards;
